:host {
  display: block;
}
.card-box-shadow {
  box-shadow: 0px 7.71px 16.38px 0px #0000001a;
}
